<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <div v-if="activityOrderRecordDTO !=null" style="padding: 20px;">

          <el-input v-model="text" clearable placeholder="备注"></el-input>

            <div style="margin-top: 20px;">
              <el-upload
                  action=""
                  :limit="1"
                  :on-preview="handlePictureCardPreview"
                  :on-change="handleChange"
                  :on-progress="onProgress"
                  :on-success="imgSuccess"
                  :on-error="imgError"
                  :http-request="uploadHttp"
                  list-type="picture-card"
                  :on-remove="handleRemove"
                  :class="{disabled:uploadDisabled}"
                  :file-list="fileList">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
                <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
              </el-dialog>
            </div>

            <div style="border-bottom:1px solid #eee; "></div>


        </div>




      </div>
      <div class="modal-footer">
        <!--        <el-button @click.native="closeSelf">取消</el-button>-->
        <el-button :loading="loading"  type="primary" @click.native="edit">保存</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Photo',
  components: {},
  props: [],
  data() {
    return {

      loading: false,

      activityOrderRecordCode:'',

      activityOrderRecordDTO:null,



      //上传身份证正面相关参数
      limitCount: 1,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

      text:'',


    }
  },
  methods: {


    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
      this.uploadDisabled = false;
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = true;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
      this.uploadDisabled = true;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.uploadDisabled = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file,fileList);
      this.uploadDisabled = false;
    },
    //图片更改
    handleChange(fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
      this.uploadDisabled = true;
    },

    uploadHttp(file) {

      //获取文件信息
      //let fileLen = file.file;
      //let name = fileLen.name

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.edit_imgPath = that.$imgUrl+res.data.data.path;
      })


    },



    init(code){

      this.activityOrderRecordCode = code;

      this.getItem();

    },

    closeSelf() {
      this.$emit("closePhotoEdit");
    },


    getItem(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrderRecord/Get2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderRecordCode:this.activityOrderRecordCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityOrderRecordDTO = response.data.data.activityOrderRecordDTO;

          this.text = this.activityOrderRecordDTO.text;

          for(let i=0;i<this.activityOrderRecordDTO.listActivityOrderRecordImg.length;i++){


            let row = this.activityOrderRecordDTO.listActivityOrderRecordImg[i];
            if(row.imgPath != '' && row.imgPath !=null){


              let obj = new Object();
              obj.url = this.$imgUrl+row.imgPath;

              this.edit_imgPath = this.$imgUrl+row.imgPath;

              this.fileList = [];
              this.fileList.push(obj);
              this.uploadDisabled= true;
            }else{
              this.fileList = [];
              this.uploadDisabled = false;
              this.edit_imgPath = "";
            }

          }


        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    edit(){

      let arr = [];
      arr.push({sort:0,imgPath:this.edit_imgPath.replace(this.$imgUrl,"")});

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrderRecord/Edit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderRecordCode:this.activityOrderRecordCode,
          remarks:this.text,
          arr:arr,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          this.$emit("closePhotoEdit");
          this.$emit("getPhotoList");

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

  }
}
</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
